<template>
  <div class="content d-flex flex-column flex-column-fluid mb-10" id="kt_content">
    <div class="toolbar" id="kt_toolbar">
      <div id="kt_toolbar_container" class="container-fluid d-flex flex-stack">
        <div data-kt-swapper="true" data-kt-swapper-mode="prepend"
          data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
          class="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
          <h1 class="d-flex text-dark fw-bolder fs-3 align-items-center my-1">{{ $t('statistics.profitability') }}</h1>
          <span class="h-20px border-gray-300 border-start mx-4"></span>
          <ul class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
            <li class="breadcrumb-item text-muted">
              <router-link to="/admin" class="text-muted text-hover-primary">{{ $t('navigation.dashboard') }}</router-link>
            </li>
            <li class="breadcrumb-item text-dark">{{ $t('statistics.profitability') }}</li>
          </ul>
        </div>
        <div class="d-flex align-items-center gap-2 gap-lg-3">
          <div class="m-0">
            <select name="filter" style="width:250px!important;" v-model="shop_selected" data-control="select2"
              data-search="true" data-placeholder="Filter"
              class="form-select kt_select_rentabilite form-select-sm border-primary w-200px me-5">
              <option value="all" selected>{{ $t('dashboard.all_shop') }}</option>
              <option v-if="$hasModule('ecommerce')" value="ecommerce">{{ $t('dashboard.ecommerce') }}</option>
              <option v-for="s in shops" :value="s.id" :key="s.id">{{ s.name }}</option>
            </select>
          </div>
          <div class="card-toolbar">
            <div dashboard-kt-daterangepicker="true" data-kt-daterangepicker-opens="left"
              class="btn btn-sm btn-light d-flex align-items-center px-4">
              <div class="text-gray-600 fw-bolder">{{ $t('dashboard.loading') }}...</div>
              <span class="svg-icon svg-icon-1 ms-2 me-0">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path opacity="0.3" d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z" fill="currentColor"/>
                  <path d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z" fill="currentColor"/>
                </svg>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="post d-flex flex-column-fluid" id="kt_post">
      <!-- Loader -->
      <div class="container-xxl" v-show="!isReady">
        <Loader text="Loading..." />
      </div>

      <div v-show="isReady" id="kt_content_container" class="container-xxl">

        <!-- KPI Cards -->
        <div class="row gy-5 g-xl-8 mb-8">
          <div class="col-md-3">
            <div class="card card-flush h-100">
              <div class="card-body pt-6 pb-4">
                <div class="d-flex align-items-center mb-2">
                  <i class="bi bi-graph-up-arrow fs-2 text-primary me-3"></i>
                  <span class="fs-2hx fw-bolder text-gray-800 lh-1">{{ fmt(kpi.ca) }}</span>
                </div>
                <span class="fs-6 fw-bold text-gray-400">{{ $t('statistics.ca') }} <small class="text-muted">({{ $t('statistics.with_purchase_price') }})</small></span>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="card card-flush h-100">
              <div class="card-body pt-6 pb-4">
                <div class="d-flex align-items-center mb-2">
                  <i class="bi bi-cart-dash fs-2 text-danger me-3"></i>
                  <span class="fs-2hx fw-bolder text-gray-800 lh-1">{{ fmt(kpi.cogs) }}</span>
                </div>
                <span class="fs-6 fw-bold text-gray-400">{{ $t('statistics.cogs') }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="card card-flush h-100">
              <div class="card-body pt-6 pb-4">
                <div class="d-flex align-items-center mb-2">
                  <i class="bi bi-currency-dollar fs-2 me-3" :class="kpi.margin >= 0 ? 'text-success' : 'text-danger'"></i>
                  <span class="fs-2hx fw-bolder lh-1" :class="kpi.margin >= 0 ? 'text-success' : 'text-danger'">{{ fmt(kpi.margin) }}</span>
                </div>
                <span class="fs-6 fw-bold text-gray-400">{{ $t('statistics.gross_margin') }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="card card-flush h-100">
              <div class="card-body pt-6 pb-4">
                <div class="d-flex align-items-center mb-2">
                  <i class="bi bi-percent fs-2 me-3" :class="kpi.marginRate >= 20 ? 'text-success' : kpi.marginRate >= 0 ? 'text-primary' : 'text-danger'"></i>
                  <span class="fs-2hx fw-bolder lh-1" :class="kpi.marginRate >= 20 ? 'text-success' : kpi.marginRate >= 0 ? 'text-primary' : 'text-danger'">
                    {{ Number(kpi.marginRate).toFixed(2) }} %
                  </span>
                </div>
                <span class="fs-6 fw-bold text-gray-400">{{ $t('statistics.margin_rate') }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Margin evolution chart -->
        <div class="row gy-5 g-xl-8 mb-8">
          <div class="col-12">
            <div class="card card-flush">
              <div class="card-header pt-5">
                <h3 class="card-title align-items-start flex-column">
                  <span class="card-label fw-bolder text-dark">{{ $t('statistics.margin_evolution') }}</span>
                </h3>
              </div>
              <div class="card-body pb-5">
                <div v-if="!byPeriod.length" class="text-center py-10">
                  <img src="@/assets/media/pos/Empty2.png" alt="" class="mw-100 h-150px"/>
                  <div class="text-gray-400 fs-5 fw-bold mt-3">{{ $t('no_data_found') }}</div>
                </div>
                <template v-else>
                  <!-- Mobile : liste de périodes -->
                  <div v-if="isMobile" class="margin-period-list">
                    <div class="margin-period-header">
                      <span>Période</span>
                      <span>CA</span>
                      <span>Marge</span>
                      <span>Taux</span>
                    </div>
                    <div
                      v-for="r in byPeriod"
                      :key="r.date"
                      class="margin-period-row"
                    >
                      <span class="margin-period-date">{{ r.date }}</span>
                      <span class="margin-period-val">{{ fmt(r.ca) }}</span>
                      <span class="margin-period-val" :class="r.margin >= 0 ? 'text-success' : 'text-danger'">
                        {{ fmt(r.margin) }}
                      </span>
                      <span class="margin-period-rate" :class="r.ca > 0 && (r.margin/r.ca*100) >= 20 ? 'text-success' : r.ca > 0 && (r.margin/r.ca*100) >= 0 ? 'text-primary' : 'text-danger'">
                        {{ r.ca > 0 ? (r.margin / r.ca * 100).toFixed(1) + '%' : '—' }}
                      </span>
                    </div>
                  </div>
                  <!-- Desktop : graphe -->
                  <div v-else id="margin-period-chart" style="height:300px"></div>
                </template>
              </div>
            </div>
          </div>
        </div>

        <!-- Top & Bottom products -->
        <div class="row gy-5 g-xl-8 mb-8">
          <div class="col-lg-6">
            <div class="card card-flush h-100">
              <div class="card-header pt-5">
                <h3 class="card-title"><span class="card-label fw-bolder text-dark">{{ $t('statistics.top_products_margin') }}</span></h3>
              </div>
              <div class="card-body pt-2 pb-4">
                <div v-if="!topProducts.length" class="text-center py-8">
                  <div class="text-gray-400 fs-5 fw-bold">{{ $t('no_data_found') }}</div>
                </div>
                <div v-else class="table-responsive">
                  <table class="table table-row-dashed table-row-gray-200 align-middle gs-0 gy-3">
                    <thead>
                      <tr class="fw-bolder text-muted fs-7 text-uppercase">
                        <th>{{ $t('statistics.product') }}</th>
                        <th class="text-end">{{ $t('statistics.ca') }}</th>
                        <th class="text-end">{{ $t('statistics.margin') }}</th>
                        <th class="text-end">{{ $t('statistics.margin_rate') }}</th>
                        <th class="text-end">{{ $t('statistics.qty') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="p in topProducts" :key="p.name">
                        <td class="fw-bold text-dark">{{ p.name }}</td>
                        <td class="text-end text-gray-600">{{ fmt(p.ca) }}</td>
                        <td class="text-end fw-bolder" :class="p.margin >= 0 ? 'text-success' : 'text-danger'">{{ fmt(p.margin) }}</td>
                        <td class="text-end">
                          <span class="badge-sm" :class="p.margin_rate >= 0 ? 'badge-light-success' : 'badge-light-danger'">{{ Number(p.margin_rate).toFixed(2) }} %</span>
                        </td>
                        <td class="text-end text-gray-600">{{ p.quantity }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="card card-flush h-100">
              <div class="card-header pt-5">
                <h3 class="card-title"><span class="card-label fw-bolder text-dark">{{ $t('statistics.bottom_products_margin') }}</span></h3>
              </div>
              <div class="card-body pt-2 pb-4">
                <div v-if="!bottomProducts.length" class="text-center py-8">
                  <div class="text-gray-400 fs-5 fw-bold">{{ $t('no_data_found') }}</div>
                </div>
                <div v-else class="table-responsive">
                  <table class="table table-row-dashed table-row-gray-200 align-middle gs-0 gy-3">
                    <thead>
                      <tr class="fw-bolder text-muted fs-7 text-uppercase">
                        <th>{{ $t('statistics.product') }}</th>
                        <th class="text-end">{{ $t('statistics.ca') }}</th>
                        <th class="text-end">{{ $t('statistics.margin') }}</th>
                        <th class="text-end">{{ $t('statistics.margin_rate') }}</th>
                        <th class="text-end">{{ $t('statistics.qty') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="p in bottomProducts" :key="p.name">
                        <td class="fw-bold text-dark">{{ p.name }}</td>
                        <td class="text-end text-gray-600">{{ fmt(p.ca) }}</td>
                        <td class="text-end fw-bolder" :class="p.margin >= 0 ? 'text-success' : 'text-danger'">{{ fmt(p.margin) }}</td>
                        <td class="text-end">
                          <span class="badge-sm" :class="p.margin_rate >= 0 ? 'badge-light-success' : 'badge-light-danger'">{{ Number(p.margin_rate).toFixed(2) }} %</span>
                        </td>
                        <td class="text-end text-gray-600">{{ p.quantity }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Produits vendus à perte & moins rentables -->
        <div class="row gy-5 g-xl-8 mb-8">
          <div class="col-lg-6">
            <div class="card card-flush h-100">
              <div class="card-header pt-5">
                <h3 class="card-title"><span class="card-label fw-bolder text-dark">{{ $t('statistics.at_loss_products') }}</span></h3>
              </div>
              <div class="card-body pt-2 pb-4">
                <div v-if="!atLossProducts.length" class="text-center py-8">
                  <i class="bi bi-emoji-smile fs-2x text-success d-block mb-3"></i>
                  <div class="text-gray-400 fs-6 fw-bold">{{ $t('statistics.no_loss_products') }}</div>
                </div>
                <div v-else class="table-responsive">
                  <table class="table table-row-dashed table-row-gray-200 align-middle gs-0 gy-3">
                    <thead>
                      <tr class="fw-bolder text-muted fs-7 text-uppercase">
                        <th>{{ $t('statistics.product') }}</th>
                        <th class="text-end">{{ $t('statistics.ca') }}</th>
                        <th class="text-end">{{ $t('statistics.margin') }}</th>
                        <th class="text-end">{{ $t('statistics.margin_rate') }}</th>
                        <th class="text-end">{{ $t('statistics.qty') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="p in atLossProducts" :key="p.name">
                        <td class="fw-bold text-dark">{{ p.name }}</td>
                        <td class="text-end text-gray-600">{{ fmt(p.ca) }}</td>
                        <td class="text-end fw-bolder text-danger">{{ fmt(p.margin) }}</td>
                        <td class="text-end">
                          <span class="badge-sm badge-light-danger">{{ Number(p.margin_rate).toFixed(2) }} %</span>
                        </td>
                        <td class="text-end text-gray-600">{{ p.quantity }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="card card-flush h-100">
              <div class="card-header pt-5">
                <h3 class="card-title"><span class="card-label fw-bolder text-dark">{{ $t('statistics.least_profitable_products') }}</span></h3>
              </div>
              <div class="card-body pt-2 pb-4">
                <div v-if="!leastProfitableProducts.length" class="text-center py-8">
                  <div class="text-gray-400 fs-5 fw-bold">{{ $t('no_data_found') }}</div>
                </div>
                <div v-else class="table-responsive">
                  <table class="table table-row-dashed table-row-gray-200 align-middle gs-0 gy-3">
                    <thead>
                      <tr class="fw-bolder text-muted fs-7 text-uppercase">
                        <th>{{ $t('statistics.product') }}</th>
                        <th class="text-end">{{ $t('statistics.ca') }}</th>
                        <th class="text-end">{{ $t('statistics.margin') }}</th>
                        <th class="text-end">{{ $t('statistics.margin_rate') }}</th>
                        <th class="text-end">{{ $t('statistics.qty') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="p in leastProfitableProducts" :key="p.name">
                        <td class="fw-bold text-dark">{{ p.name }}</td>
                        <td class="text-end text-gray-600">{{ fmt(p.ca) }}</td>
                        <td class="text-end fw-bolder" :class="p.margin >= 0 ? 'text-success' : 'text-danger'">{{ fmt(p.margin) }}</td>
                        <td class="text-end">
                          <span class="badge-sm" :class="p.margin_rate >= 0 ? 'badge-light-success' : 'badge-light-danger'">{{ Number(p.margin_rate).toFixed(2) }} %</span>
                        </td>
                        <td class="text-end text-gray-600">{{ p.quantity }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Discounts impact (fidélité + promotions) -->
        <div class="row gy-5 g-xl-8 mb-8">
          <div class="col-12">
            <div class="card card-flush">
              <div class="card-header pt-5">
                <h3 class="card-title align-items-start flex-column">
                  <span class="card-label fw-bolder text-dark">{{ $t('statistics.discounts_impact') }}</span>
                  <span class="text-muted mt-1 fw-bold fs-7">{{ $t('statistics.discounts_impact_desc') }}</span>
                </h3>
              </div>
              <div class="card-body pt-2 pb-4">
                <div class="row gy-4">
                  <div class="col-6 col-md-3">
                    <div class="fs-6 fw-bold text-gray-400">{{ $t('statistics.loyalty_discount') }}</div>
                    <div class="fs-3 fw-bolder text-danger">{{ fmt(discountsImpact.loyalty) }}</div>
                  </div>
                  <div class="col-6 col-md-3">
                    <div class="fs-6 fw-bold text-gray-400">{{ $t('statistics.promo_discount') }}</div>
                    <div class="fs-3 fw-bolder text-danger">{{ fmt(discountsImpact.promotions) }}</div>
                  </div>
                  <div class="col-6 col-md-3">
                    <div class="fs-6 fw-bold text-gray-400">{{ $t('statistics.net_ca') }}</div>
                    <div class="fs-3 fw-bolder text-dark">{{ fmt(discountsImpact.net_ca) }}</div>
                  </div>
                  <div class="col-6 col-md-3">
                    <div class="fs-6 fw-bold text-gray-400">{{ $t('statistics.net_margin') }} ({{ $t('statistics.net_margin_rate') }})</div>
                    <div class="fs-3 fw-bolder" :class="discountsImpact.net_margin >= 0 ? 'text-success' : 'text-danger'">
                      {{ fmt(discountsImpact.net_margin) }}
                      <span class="fs-6 fw-bold text-gray-400">({{ Number(discountsImpact.net_margin_rate).toFixed(2) }} %)</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- By channel -->
        <div class="row gy-5 g-xl-8 mb-8" v-if="byChannel.length">
          <div class="col-12">
            <div class="card card-flush">
              <div class="card-header pt-5">
                <h3 class="card-title"><span class="card-label fw-bolder text-dark">{{ $t('statistics.margin_by_channel') }}</span></h3>
              </div>
              <div class="card-body pt-2 pb-4">
                <div class="table-responsive">
                  <table class="table table-row-dashed table-row-gray-200 align-middle gs-0 gy-3">
                    <thead>
                      <tr class="fw-bolder text-muted fs-7 text-uppercase">
                        <th>{{ $t('statistics.channel') }}</th>
                        <th class="text-end">{{ $t('statistics.ca') }}</th>
                        <th class="text-end">{{ $t('statistics.cogs') }}</th>
                        <th class="text-end">{{ $t('statistics.margin') }}</th>
                        <th class="text-end">{{ $t('statistics.margin_rate') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="c in byChannel" :key="c.name">
                        <td class="fw-bold text-dark">
                          <span class="badge" :class="c.name === 'POS' ? 'badge-light-primary' : 'badge-light-info'">{{ c.name }}</span>
                        </td>
                        <td class="text-end text-gray-600">{{ fmt(c.ca) }}</td>
                        <td class="text-end text-gray-600">{{ fmt(c.cogs) }}</td>
                        <td class="text-end fw-bolder" :class="c.margin >= 0 ? 'text-success' : 'text-danger'">{{ fmt(c.margin) }}</td>
                        <td class="text-end">
                          <span class="badge-sm" :class="c.margin_rate >= 0 ? 'badge-light-success' : 'badge-light-danger'">{{ Number(c.margin_rate).toFixed(2) }} %</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Bestsellers vs Rentables -->
        <div class="row gy-5 g-xl-8 mb-8">
          <div class="col-12">
            <div class="card card-flush">
              <div class="card-header pt-5">
                <h3 class="card-title align-items-start flex-column">
                  <span class="card-label fw-bolder text-dark">{{ $t('statistics.bestsellers_vs_profitable') }}</span>
                  <span class="text-muted mt-1 fw-bold fs-7">{{ $t('statistics.bestsellers_vs_profitable_desc') }}</span>
                </h3>
              </div>
              <div class="card-body pt-2 pb-4">
                <div v-if="!bestsellersVsProfitable.length" class="text-center py-8">
                  <div class="text-gray-400 fs-5 fw-bold">{{ $t('no_data_found') }}</div>
                </div>
                <div v-else class="table-responsive">
                  <table class="table table-row-dashed table-row-gray-200 align-middle gs-0 gy-3">
                    <thead>
                      <tr class="fw-bolder text-muted fs-7 text-uppercase">
                        <th>#</th>
                        <th>{{ $t('statistics.product') }}</th>
                        <th class="text-end">{{ $t('statistics.qty') }}</th>
                        <th class="text-end">{{ $t('statistics.ca') }}</th>
                        <th class="text-end">{{ $t('statistics.margin') }}</th>
                        <th class="text-end">{{ $t('statistics.margin_rate') }}</th>
                        <th style="min-width:140px">{{ $t('statistics.profitability') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(p, i) in bestsellersVsProfitable" :key="p.name">
                        <td class="text-muted fw-bold">{{ i + 1 }}</td>
                        <td class="fw-bold text-dark">{{ p.name }}</td>
                        <td class="text-end fw-bold text-primary">{{ p.quantity }}</td>
                        <td class="text-end text-gray-600">{{ fmt(p.ca) }}</td>
                        <td class="text-end fw-bolder" :class="p.margin >= 0 ? 'text-success' : 'text-danger'">{{ fmt(p.margin) }}</td>
                        <td class="text-end">
                          <span class="badge-sm" :class="p.margin_rate >= 20 ? 'badge-light-success' : p.margin_rate >= 0 ? 'badge-light-primary' : 'badge-light-danger'">
                            {{ Number(p.margin_rate).toFixed(2) }} %
                          </span>
                        </td>
                        <td>
                          <div class="d-flex align-items-center gap-2">
                            <div class="progress flex-grow-1" style="height:8px">
                              <div class="progress-bar"
                                :class="p.margin_rate >= 20 ? 'bg-success' : p.margin_rate >= 0 ? 'bg-primary' : 'bg-danger'"
                                :style="{ width: Math.min(Math.abs(p.margin_rate), 100) + '%' }"></div>
                            </div>
                            <i v-if="p.margin_rate >= 20" class="bi bi-emoji-smile-fill text-success fs-6" :title="$t('statistics.profitable')"></i>
                            <i v-else-if="p.margin_rate >= 0" class="bi bi-emoji-neutral-fill text-primary fs-6" :title="$t('statistics.low_margin')"></i>
                            <i v-else class="bi bi-emoji-frown-fill text-danger fs-6" :title="$t('statistics.negative_margin')"></i>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- By category -->
        <div class="row gy-5 g-xl-8 mb-8">
          <div class="col-12">
            <div class="card card-flush">
              <div class="card-header pt-5">
                <h3 class="card-title"><span class="card-label fw-bolder text-dark">{{ $t('statistics.margin_by_category') }}</span></h3>
              </div>
              <div class="card-body pt-2 pb-4">
                <div v-if="!byCategory.length" class="text-center py-8">
                  <div class="text-gray-400 fs-5 fw-bold">{{ $t('no_data_found') }}</div>
                </div>
                <div v-else class="table-responsive">
                  <table class="table table-row-dashed table-row-gray-200 align-middle gs-0 gy-3">
                    <thead>
                      <tr class="fw-bolder text-muted fs-7 text-uppercase">
                        <th>{{ $t('navigation.category') }}</th>
                        <th class="text-end">{{ $t('statistics.ca') }}</th>
                        <th class="text-end">{{ $t('statistics.cogs') }}</th>
                        <th class="text-end">{{ $t('statistics.margin') }}</th>
                        <th class="text-end">{{ $t('statistics.margin_rate') }}</th>
                        <th style="min-width:180px">{{ $t('statistics.margin_bar') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="c in byCategory" :key="c.name">
                        <td class="fw-bold text-dark">{{ c.name }}</td>
                        <td class="text-end text-gray-600">{{ fmt(c.ca) }}</td>
                        <td class="text-end text-gray-600">{{ fmt(c.cogs) }}</td>
                        <td class="text-end fw-bolder" :class="c.margin >= 0 ? 'text-success' : 'text-danger'">{{ fmt(c.margin) }}</td>
                        <td class="text-end">
                          <span class="badge-sm" :class="c.margin_rate >= 0 ? 'badge-light-success' : 'badge-light-danger'">{{ Number(c.margin_rate).toFixed(2) }} %</span>
                        </td>
                        <td>
                          <div class="d-flex align-items-center">
                            <div class="progress flex-grow-1 me-2" style="height:8px">
                              <div class="progress-bar" :class="c.margin_rate >= 0 ? 'bg-success' : 'bg-danger'"
                                :style="{ width: Math.min(Math.abs(c.margin_rate), 100) + '%' }"></div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- By shop & By seller (POS uniquement) -->
        <div class="row gy-5 g-xl-8 mb-8" v-if="shop_selected !== 'ecommerce'">
          <div class="col-12 mb-2">
            <div class="d-flex align-items-center">
              <i class="bi bi-shop fs-4 text-primary me-2"></i>
              <span class="fw-bolder text-dark fs-5">{{ $t('statistics.pos_only_section') }}</span>
              <span class="ms-2 badge badge-light-primary">POS</span>
            </div>
            <div class="text-muted fs-7 mt-1">{{ $t('statistics.pos_only_desc') }}</div>
          </div>

          <div class="col-12">
            <div class="card card-flush h-100">
              <div class="card-header pt-5">
                <h3 class="card-title"><span class="card-label fw-bolder text-dark">{{ $t('statistics.margin_by_shop') }}</span></h3>
              </div>
              <div class="card-body pt-2 pb-4">
                <div v-if="!byShop.length" class="text-center py-8">
                  <i class="bi bi-shop fs-2x text-gray-300 d-block mb-3"></i>
                  <div class="text-gray-400 fs-6 fw-bold">{{ $t('statistics.no_pos_sales') }}</div>
                </div>
                <div v-else class="table-responsive">
                  <table class="table table-row-dashed table-row-gray-200 align-middle gs-0 gy-3">
                    <thead>
                      <tr class="fw-bolder text-muted fs-7 text-uppercase">
                        <th>{{ $t('navigation.shop') }}</th>
                        <th class="text-end">{{ $t('statistics.ca') }}</th>
                        <th class="text-end">{{ $t('statistics.margin') }}</th>
                        <th class="text-end">{{ $t('statistics.margin_rate') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="s in byShop" :key="s.name">
                        <td class="fw-bold text-dark">{{ s.name }}</td>
                        <td class="text-end text-gray-600">{{ fmt(s.ca) }}</td>
                        <td class="text-end fw-bolder" :class="s.margin >= 0 ? 'text-success' : 'text-danger'">{{ fmt(s.margin) }}</td>
                        <td class="text-end">
                          <span class="badge-sm" :class="s.margin_rate >= 0 ? 'badge-light-success' : 'badge-light-danger'">{{ Number(s.margin_rate).toFixed(2) }} %</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-6">
          </div>
        </div>

        <!-- Message si filtre ecommerce uniquement -->
        <div class="row gy-5 g-xl-8 mb-8" v-if="shop_selected === 'ecommerce'">
          <div class="col-12">
            <div class="card card-flush border border-dashed border-primary">
              <div class="card-body py-6 d-flex align-items-center">
                <i class="bi bi-info-circle-fill fs-2 text-primary me-4"></i>
                <div>
                  <div class="fw-bolder text-dark fs-6">{{ $t('statistics.pos_only_section') }}</div>
                  <div class="text-muted fs-7 mt-1">{{ $t('statistics.pos_ecommerce_note') }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Loader from '@/components/Loader.vue'

export default {
  components: { Loader },
  data() {
    return {
      startDate: null,
      endDate: null,
      shops: [],
      shop_selected: 'all',
      isReady: false,
      currency: '',
      kpi: { ca: 0, cogs: 0, margin: 0, marginRate: 0 },
      byPeriod: [],
      topProducts: [],
      bottomProducts: [],
      bestsellersVsProfitable: [],
      byCategory: [],
      byShop: [],
      bySeller: [],
      byChannel: [],
      discountsImpact: { loyalty: 0, promotions: 0, total: 0, gross_margin: 0, net_ca: 0, net_margin: 0, net_margin_rate: 0 },
      atLossProducts: [],
      leastProfitableProducts: [],
      periodChart: null,
      isMobile: window.innerWidth <= 767,
    }
  },

  watch: {
    shop_selected(val) {
      if (val) this.$nextTick(() => this.load())
    },
    '$i18n.locale'() {
      this.$nextTick(() => this.initDateRange())
    },
  },

  beforeUnmount() {
    window.removeEventListener('resize', this._onResize)
  },

  async mounted() {
    this.isReady = false
    window.addEventListener('resize', this._onResize = () => {
      this.isMobile = window.innerWidth <= 767
    })
    KTApp.initSelect2()
    await this.loadShops()
    await this.initSelect()
    this.initDateRange()
    const res = await this.getCurrency()
    this.currency = res?.data?.currency_symbol || res?.data?.symbol_native || ''
  },

  methods: {
    ...mapActions('shop', ['getCurrency']),

    fmt(val) {
      if (val === null || val === undefined) return '—'
      return Number(val).toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
        + (this.currency ? ' ' + this.currency : '')
    },

    async loadShops() {
      try {
        const res = await axios.get('/dashboard/shops')
        this.shops = res.data.shops || []
      } catch (e) {
        console.error(e)
      }
    },

    async initSelect() {
      const sel = $('body .kt_select_rentabilite')
      sel.select2()
      sel.change((e) => {
        if (e.target.name === 'filter') this.shop_selected = e.target.value
      })
    },

    initDateRange() {
      let element = document.querySelector('[dashboard-kt-daterangepicker="true"]')
      let start = moment().subtract(29, 'days')
      let end = moment()

      this.startDate = start.format('DD-MM-YYYY')
      this.endDate   = end.format('DD-MM-YYYY')

      $(element).daterangepicker({
        direction: KTUtil.isRTL(),
        startDate: start,
        endDate: end,
        opens: 'left',
        applyClass: 'btn-primary',
        cancelClass: 'btn-light-primary',
        locale: {
          format: 'DD/MM/YYYY',
          separator: ' - ',
          applyLabel: i18n.global.t('apply'),
          cancelLabel: i18n.global.t('cancel'),
          fromLabel: i18n.global.t('from'),
          toLabel: i18n.global.t('to'),
          customRangeLabel: i18n.global.t('custom_range'),
          weekLabel: 'S',
          daysOfWeek: [i18n.global.t('di'), i18n.global.t('lu'), i18n.global.t('ma'), i18n.global.t('me'), i18n.global.t('je'), i18n.global.t('ve'), i18n.global.t('sa')],
          monthNames: [i18n.global.t('january'), i18n.global.t('february'), i18n.global.t('march'), i18n.global.t('april'), i18n.global.t('may'),
            i18n.global.t('june'), i18n.global.t('july'), i18n.global.t('august'), i18n.global.t('september'), i18n.global.t('october'), i18n.global.t('november'), i18n.global.t('december')],
          firstDay: 1,
        },
        ranges: {
          [i18n.global.t('today')]: [moment(), moment()],
          [i18n.global.t('yesterday')]: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
          [i18n.global.t('last7Days')]: [moment().subtract(6, 'days'), moment()],
          [i18n.global.t('last30Days')]: [moment().subtract(29, 'days'), moment()],
          [i18n.global.t('thisMonth')]: [moment().startOf('month'), moment().endOf('month')],
          [i18n.global.t('lastMonth')]: [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        },
      }, this.cb)

      this.cb(start, end)
    },

    async cb(start, end) {
      let element = document.querySelector('[dashboard-kt-daterangepicker="true"]')
      let display = element.querySelector('div')
      if (display) {
        display.innerHTML = start.format('D MMM YYYY') + ' - ' + end.format('D MMM YYYY')
      }
      this.startDate = start.format('DD-MM-YYYY')
      this.endDate   = end.format('DD-MM-YYYY')
      if (this.startDate && this.endDate) {
        await this.load()
      }
    },

    async load() {
      this.isReady = false
      try {
        const res = await axios.get(
          `/get/stats/profitability?shop=${this.shop_selected}&startDate=${this.startDate}&endDate=${this.endDate}`
        )
        const d = res.data
        this.kpi            = { ca: d.kpi.ca, cogs: d.kpi.cogs, margin: d.kpi.margin, marginRate: d.kpi.marginRate }
        this.byPeriod = (d.by_period || []).sort((a, b) => {
          const toTs = s => { const [dd, mm, yy] = s.split('-'); return new Date(`${yy}-${mm}-${dd}`) }
          return toTs(a.date) - toTs(b.date)
        })
        this.topProducts             = d.top_products              || []
        this.bottomProducts          = d.bottom_products           || []
        this.bestsellersVsProfitable = d.bestsellers_vs_profitable || []
        this.byCategory              = d.by_category               || []
        this.byShop         = d.by_shop        || []
        this.bySeller       = d.by_seller      || []
        this.byChannel             = (d.by_channel || []).slice().sort((a, b) => b.margin - a.margin)
        this.discountsImpact       = d.discounts_impact           || this.discountsImpact
        this.atLossProducts        = d.at_loss_products           || []
        this.leastProfitableProducts = d.least_profitable_products || []
      } catch (e) {
        console.error(e)
      }
      this.isReady = true
      await this.$nextTick()
      this.drawPeriodChart()
    },

    drawPeriodChart() {
      if (this.periodChart) { this.periodChart.destroy(); this.periodChart = null }
      if (!this.byPeriod.length) return

      const el = document.querySelector('#margin-period-chart')
      if (!el) return

      const gray   = KTUtil.getCssVariableValue('--bs-gray-500')
      const dashed = KTUtil.getCssVariableValue('--bs-border-dashed-color')
      const cur    = this.currency ? ' ' + this.currency : ''

      this.periodChart = new ApexCharts(el, {
        series: [
          {
            name: "Chiffre d'affaires",
            data: this.byPeriod.map(r => parseFloat(r.ca.toFixed(2))),
          },
          {
            name: 'Marge commerciale',
            data: this.byPeriod.map(r => parseFloat(r.margin.toFixed(2))),
          },
        ],
        chart: {
          fontFamily: 'inherit',
          type: 'bar',
          height: 350,
          toolbar: { show: false },
        },
        plotOptions: {
          bar: { columnWidth: '55%', borderRadius: 4, dataLabels: { position: 'top' } },
        },
        dataLabels: { enabled: false },
        xaxis: {
          categories: this.byPeriod.map(r => r.date),
          labels: {
            rotate: -30,
            hideOverlappingLabels: true,
            style: { colors: gray, fontSize: '11px' },
          },
          axisBorder: { show: false },
          axisTicks: { show: false },
        },
        yaxis: {
          labels: {
            style: { colors: gray, fontSize: '11px' },
            formatter: v => Number(v).toLocaleString('fr-FR', { maximumFractionDigits: 0 }),
          },
        },
        colors: ['#1565c0', '#50CD89'],
        legend: { show: true, position: 'top', markers: { radius: 4 } },
        grid: { borderColor: dashed, strokeDashArray: 4, yaxis: { lines: { show: true } } },
        tooltip: {
          shared: true,
          intersect: false,
          custom: ({ series, dataPointIndex }) => {
            const ca     = series[0][dataPointIndex]
            const margin = series[1][dataPointIndex]
            const rate   = ca > 0 ? ((margin / ca) * 100).toFixed(1) : '0'
            const fmt    = v => Number(v).toLocaleString('fr-FR', { maximumFractionDigits: 0 }) + cur
            const rateColor = parseFloat(rate) >= 20 ? '#50CD89' : parseFloat(rate) >= 0 ? '#1565c0' : '#f1416c'
            return `
              <div style="padding:10px 14px;font-family:inherit;font-size:13px;min-width:180px">
                <div style="font-weight:700;margin-bottom:8px;color:#1e2130">${this.byPeriod[dataPointIndex].date}</div>
                <div style="display:flex;justify-content:space-between;gap:16px;margin-bottom:4px">
                  <span style="color:#888">CA</span>
                  <span style="font-weight:600;color:#1565c0">${fmt(ca)}</span>
                </div>
                <div style="display:flex;justify-content:space-between;gap:16px;margin-bottom:4px">
                  <span style="color:#888">Marge</span>
                  <span style="font-weight:600;color:#50CD89">${fmt(margin)}</span>
                </div>
                <div style="display:flex;justify-content:space-between;gap:16px;border-top:1px solid #eee;padding-top:6px;margin-top:4px">
                  <span style="color:#888">Taux de marge</span>
                  <span style="font-weight:700;color:${rateColor}">${rate}%</span>
                </div>
              </div>`
          },
        },
      })
      this.periodChart.render()
    },
  },
}
</script>

<style scoped>
.margin-period-list {
  overflow-x: auto;
  border-radius: 8px;
  border: 1px solid #e4e6ef;
}

.margin-period-header,
.margin-period-row {
  display: grid;
  grid-template-columns: 1.8fr 1.5fr 1.5fr 1fr;
  align-items: center;
  padding: 10px 12px;
  gap: 8px;
}

.margin-period-header {
  background: #f5f5f5;
  font-size: 0.72rem;
  font-weight: 700;
  color: #a1a5b7;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 1px solid #e4e6ef;
}

.margin-period-row {
  border-bottom: 1px solid #f0f0f0;
  font-size: 0.82rem;
}
.margin-period-row:last-child { border-bottom: none; }
.margin-period-row:nth-child(even) { background: #fafafa; }

.margin-period-date {
  font-weight: 600;
  color: #3f4254;
  white-space: nowrap;
}

.margin-period-val {
  font-weight: 600;
  color: #1e2130;
  white-space: nowrap;
}

.margin-period-rate {
  font-weight: 700;
  text-align: right;
}
</style>
